import { getApps, initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { environment } from '../../../environments/environment';

const firebaseAppForAppCheck = getApps().length
  ? getApps()[0]
  : initializeApp(environment.firebase);

let appCheckInitialized = false;

export function initializeFirebaseAppCheck(): void {
  if (typeof window === 'undefined' || appCheckInitialized) return;
  if (!environment.appCheck?.siteKey) return;
  appCheckInitialized = true;

  if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
    (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = 'DD0BFE64-51FC-4B17-BE3E-F9789C82933E';
  }

  initializeAppCheck(firebaseAppForAppCheck, {
    provider: new ReCaptchaV3Provider(environment.appCheck.siteKey),
    isTokenAutoRefreshEnabled: true
  });
}
